import React from 'react'

export const StatusBadge = ({ status }) => {
    const getStatusStyles = (status) => {
        const normalized = (status || '').toLowerCase()
        switch (normalized) {
            case 'implemented':
            case 'active':
                return 'bg-blue-100 text-blue-800'
            case 'approved':
            case 'published':
                return 'bg-green-100 text-green-800'
            case 'pending':
            case 'draft':
                return 'bg-yellow-100 text-yellow-800'
            case 'archived':
            case 'inactive':
                return 'bg-gray-200 text-gray-700'
            default:
                return 'bg-gray-100 text-gray-800'
        }
    }


    const formatStatus = (status) => {
        if (!status) return 'Unknown'
        return status
            .toString()
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (c) => c.toUpperCase())
    }
    return (
        <div>
            <span
                className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${getStatusStyles(
                    status
                )}`}
            >
                {formatStatus(status)}
            </span>
        </div>
    )
}
